import React, { CSSProperties } from "react";
import { IonChip, IonIcon, IonLabel } from "@ionic/react";

interface Props {
  text: string;
  center?: boolean;
  disabled?: boolean;
  icon?: string;
  onTop?: boolean;
  labelStyle?: CSSProperties;
}

const SubHeader: React.FC<Props> = ({
  text,
  children,
  disabled,
  icon,
  onTop,
  labelStyle,
}) => (
  // The chip grows with its text (wrap-text), so a long name wraps inside it on phones,
  // and the price keeps its own unbroken space on the right.
  <IonChip
    className="wrap-text"
    style={{
      display: "flex",
      minHeight: 50,
      padding: "8px 14px",
      columnGap: 8,
      marginBottom: 10,
      marginTop: onTop ? 5 : 20,
    }}
    disabled={disabled}
  >
    <IonIcon icon={icon} size="large" color="dark" style={{ flexShrink: 0 }} />
    <IonLabel className="f15" style={{ lineHeight: 1.3, ...labelStyle }}>
      {text}
    </IonLabel>
    {children && (
      <div style={{ marginLeft: "auto", flexShrink: 0 }}>{children}</div>
    )}
  </IonChip>
);

export default SubHeader;
